export default function ({ store, redirect, route, $sentry }) {
  $sentry.setTag('path', route.path)
  $sentry.setTag('query', JSON.stringify(route.query))

  function checkExpiration (expirationTime) {
    // calculate password expiration remaining day
    const today = new Date()
    const expiration = new Date(expirationTime * 1000)
    const diffTime = expiration - today
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    return diffDays
  }

  if (route.query && route.query.token) {
    // temporary only for present, will improve soon
    store.commit('user/SET_USER_TOKEN', route.query.token)
    store.commit('user/SET_USER_EXPIRATION', route.query.expiration)
    store.commit('user/SET_USER_EMAIL', route.query.email)
    store.commit('user/SET_USER_IS_LOGGED', true)
    store.commit('user/SET_USER_ROLE', route.query.role)
    if (route.query.role && route.query.role === 'admin') {
      store.commit('user/SET_USER_ROLE_ENDPOINT', 'admin/doctor/')
    } else {
      store.commit('user/SET_USER_ROLE_ENDPOINT', 'doctor/')
    }

    if (route.query.expiration) {
      const remainingDays = checkExpiration(route.query.expiration)
      if (remainingDays <= 7) {
        return redirect('/auth/update-password')
      } else {
        return redirect('/console/calendar')
      }
    } else {
      return redirect('/console/calendar')
    }
  }
  if (route.query &&
      route.query.expiration != null &&
      route.query.email != null &&
      route.query.role != null) {
    store.commit('user/SET_USER_EXPIRATION', route.query.expiration)
    store.commit('user/SET_USER_EMAIL', route.query.email)
    store.commit('user/SET_USER_ROLE', route.query.role)

    const remainingDays = checkExpiration(route.query.expiration)
    if (remainingDays <= 7) {
      return redirect('/auth/update-password')
    }
  }
  if (!store.state.user.auth.isAuth) { return redirect('/auth/login') }
  if (store.state.user.auth.expiration) {
    const remainingDays = checkExpiration(store.state.user.auth.expiration)
    if (remainingDays <= 0) {
      return redirect('/auth/update-password')
    }
  }
}
